import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MapListItem from './MapListItem';
import {  setMappedFields } from 'redux/mapping/MappingActions';

const mapStateToProps = (state, ownProps) => {
  const mappedField = state.mapping.tempMappedFieldsInDivision.find(e => (e.sourceField === ownProps.sourceName && e.subGroup === ownProps.subGroup && e.activeDivision === ownProps.activeDivision));
  return ({
    targetFields: state.targetFields.tempDivisionFields,
    selectedTarget: mappedField ? mappedField.targetField : ''
  });
};

const mapDispatchToProps = dispatch => ({
  mappingActions: bindActionCreators({ setMappedFields }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(MapListItem);



// WEBPACK FOOTER //
// ./src/shared/components/mapColumns/c/columnListsSlidingPanel/c/columnLists/c/mapListItem/MapListItemConnector.js